"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getServiceIdentifierName_1 = __importDefault(require("./getServiceIdentifierName"));
const messagesMap = {
    alreadyRunning: "You are trying to run InversifySugar twice.",
    resolveProvider: (serviceIdentifier, containerId) => {
        const serviceIdentifierName = (0, getServiceIdentifierName_1.default)(serviceIdentifier);
        return `[provider] Resolving ${serviceIdentifierName} in container ${containerId}.`;
    },
    moduleProvidersBinded: (moduleName) => `[@module] ${moduleName} providers binded.`,
    notAModuleImported: (importedItemName) => `importModule() was called with a class that is not a module: ${importedItemName}. Skipping...`,
    notAModuleUnbinded: (unbindedItemName) => `unbindModule() was called with a class that is not a module: ${unbindedItemName}. Skipping...`,
    notBoundProviderExported: (moduleName, provide) => `You are trying to export a provider that is not bound in the module ${moduleName}: ${provide}.`,
};
exports.default = messagesMap;
